import {
    UNAVAILABLE_TIMES_DAYS_PRIOR,
    UNAVAILABLE_TIMES_DAYS_FOLLOWING,
    UNAVAILABLE_TIMES_MAX_DAYS_PRIOR,
    UNAVAILABLE_TIMES_MAX_DAYS_FOLLOWING,
    UNAVAILABLE_PRIOR_REASON,
    UNAVAILABLE_FOLLOWING_REASON,
} from '../constants/bookingUnavailability';

import {
    BOOKING_STATUS_UNAPPROVED,
    BOOKING_STATUS_APPROVED,
    BOOKING_STATUS_CHECKED_OUT,
    BOOKING_STATUS_CHECKED_IN,
    BOOKING_STATUS_CANCELLED,
} from '../constants/booking';

import _find from 'lodash/find';
import _findLast from 'lodash/findLast';

export const bookingStatusToCssClass = (bookingstatusId) => {
    switch (bookingstatusId) {
        case BOOKING_STATUS_UNAPPROVED:
            return `unapproved`;
        case BOOKING_STATUS_APPROVED:
            return `approved`;
        case BOOKING_STATUS_CHECKED_OUT:
            return `checked-out`;
        case BOOKING_STATUS_CHECKED_IN:
            return `checked-in`;
        case BOOKING_STATUS_CANCELLED:
            return `cancelled`;
        default:
            return null;
    }
};

export const bookingStatusToText = (bookingStatusId) => {
    switch (bookingStatusId) {
        case BOOKING_STATUS_UNAPPROVED:
            return `Unapproved`;
        case BOOKING_STATUS_APPROVED:
            return `Approved`;
        case BOOKING_STATUS_CHECKED_OUT:
            return `Checked out`;
        case BOOKING_STATUS_CHECKED_IN:
            return `Checked in`;
        case BOOKING_STATUS_CANCELLED:
            return `Cancelled`;
        default:
            return null;
    }
};

export const getStartEndTimesBasedOnBookingStatus = (booking) => {
    switch (booking.statusId) {
        case BOOKING_STATUS_CHECKED_OUT:
            return {
                start: booking.checkOutTime.clone(),
                end: booking.endTime.clone(),
            };
        case BOOKING_STATUS_CHECKED_IN:
            return {
                start: booking.checkOutTime.clone(),
                end: booking.checkInTime.clone(),
            };
        case BOOKING_STATUS_UNAPPROVED:
        case BOOKING_STATUS_APPROVED:
        case BOOKING_STATUS_CANCELLED:
        default:
            return {
                start: booking.startTime.clone(),
                end: booking.endTime.clone(),
            };
    }
};

export const getBookingPlant = (booking, plant) => {
    let bookingPlant;
    if (!booking.vehiclePlantId ) {
        bookingPlant = booking.additionalPlantIds
            ? plant[booking.additionalPlantIds[0]]
            : null;
    } else {
        bookingPlant = plant[booking.vehiclePlantId];
    }

    return bookingPlant;
};

const canEditBookingTimes = (statusId) => {
    return statusId !== BOOKING_STATUS_CANCELLED && statusId !== BOOKING_STATUS_CHECKED_IN;
};

export const canEditStartTime = (statusId, canEditStartTime) => {
    return (statusId === BOOKING_STATUS_APPROVED || statusId === BOOKING_STATUS_UNAPPROVED) && canEditStartTime;
};

export const canEditEndTime = (statusId, canEditEndTime) => {
    return (canEditBookingTimes(statusId) && statusId !== BOOKING_STATUS_CHECKED_IN) && canEditEndTime;
};

export const getAvailabilityWindow = (booking, unavailability) => {
    if (!unavailability)
        return null;

    const bookingTimes = getStartEndTimesBasedOnBookingStatus(booking);

    // find closest booking before the one we are editing
    const left = _findLast(unavailability.unavailableSlots, slot =>
        slot.endTime.isSameOrBefore(bookingTimes.end)
    );

    let minStartDate;
    let startTimeUnavailabilityReasons;
    if (left) {
        const maxMinBookingTime = bookingTimes.start.clone().add(UNAVAILABLE_TIMES_MAX_DAYS_PRIOR, `d`);
        minStartDate = left.endTime.isBefore(maxMinBookingTime) ? maxMinBookingTime : left.endTime;
        startTimeUnavailabilityReasons = left.reasons;
    } else {
        minStartDate = bookingTimes.start.clone().startOf(`day`).subtract(UNAVAILABLE_TIMES_DAYS_PRIOR, `days`);
        startTimeUnavailabilityReasons = [UNAVAILABLE_PRIOR_REASON];
    }

    // find the closest booking after the one we are editing
    const right = _find(unavailability.unavailableSlots, slot =>
        slot.endTime.isSameOrAfter(bookingTimes.end)
    );

    let maxEndDate;
    let endTimeUnavailabilityReasons;
    if (right) {
        const minMaxBookingTime = bookingTimes.end.clone().add(UNAVAILABLE_TIMES_MAX_DAYS_FOLLOWING, `d`);
        maxEndDate = right.startTime.isAfter(minMaxBookingTime) ? minMaxBookingTime : right.startTime;
        endTimeUnavailabilityReasons = right.reasons;
    } else {
        maxEndDate = bookingTimes.end.clone().startOf(`day`).add(UNAVAILABLE_TIMES_DAYS_FOLLOWING, `days`);
        endTimeUnavailabilityReasons = [UNAVAILABLE_FOLLOWING_REASON];
    }

    // sanity check to ensure that the minStartDate and maxEndDate that we return are within the bounds specified by the currently status of the booking
    const valid = bookingTimes.start.isSameOrAfter(minStartDate) && bookingTimes.end.isSameOrBefore(maxEndDate);

    return {
        valid,
        minStartDate,
        maxEndDate,
        startTimeUnavailabilityReasons,
        endTimeUnavailabilityReasons,
    };
};



// WEBPACK FOOTER //
// ./scripts/util/bookingHelpers.js